import { render, staticRenderFns } from "./AllForums.vue?vue&type=template&id=51b4e9d9"
import script from "./AllForums.vue?vue&type=script&lang=js"
export * from "./AllForums.vue?vue&type=script&lang=js"
import style0 from "./AllForums.vue?vue&type=style&index=0&id=51b4e9d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports